export const getBulkUploadTimestamp = (upload) => {
  const dateValue = upload?.uploadDate || upload?.createdAt || upload?.createdOn;
  const timestamp = new Date(dateValue || 0).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};
